import { c as _c } from "react/compiler-runtime";
import { Card, CardContent } from '@achra/ui/card';
import Image from 'next/image';
import Link from 'next/link';
import { SERVICE_INFO_DEFAULT_COVER_PATH } from '../../lib/constants';
import { ServiceBadge } from '../service-badge';
import type { EnrichedService } from '../../types';
import type { Route } from 'next';
interface ServiceMarketplaceCardProps {
  enrichedService: EnrichedService;
}
function ServiceMarketplaceCard(t0) {
  const $ = _c(27);
  const {
    enrichedService
  } = t0;
  const {
    service,
    badge,
    operatorName
  } = enrichedService;
  const coverImage = service.thumbnailUrl ?? SERVICE_INFO_DEFAULT_COVER_PATH;
  const t1 = `/services/${service.id}` as Route;
  const t2 = `${service.title} Profile`;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = <Link href={t1} className="absolute inset-0 z-10 rounded-xl" aria-label={t2} />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== coverImage || $[4] !== service.title) {
    t4 = <div className="relative size-12 shrink-0 overflow-hidden rounded-lg"><Image src={coverImage} alt={service.title} fill={true} unoptimized={true} className="bg-accent rounded-lg object-cover" /></div>;
    $[3] = coverImage;
    $[4] = service.title;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== service.title) {
    t5 = <span className="text-foreground truncate text-sm leading-tight font-semibold sm:text-base">{service.title}</span>;
    $[6] = service.title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== operatorName) {
    t6 = operatorName && <span className="text-muted-foreground text-xs">by {operatorName}</span>;
    $[8] = operatorName;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="flex min-w-0 flex-col gap-1">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t7) {
    t8 = <div className="flex items-center gap-3">{t4}{t7}</div>;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== service.summary) {
    t9 = service.summary && <p className="text-foreground line-clamp-3 text-xs leading-relaxed sm:text-sm">{service.summary}</p>;
    $[16] = service.summary;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== badge) {
    t10 = badge && <div className="mt-auto"><ServiceBadge badge={badge} /></div>;
    $[18] = badge;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t8 || $[22] !== t9) {
    t11 = <CardContent className="flex h-full flex-col gap-3 p-4">{t8}{t9}{t10}</CardContent>;
    $[20] = t10;
    $[21] = t8;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t3) {
    t12 = <Card className="bg-card hover:border-border relative overflow-hidden border border-transparent p-0 transition-[box-shadow,border-color] duration-200 ease-out hover:shadow-lg">{t3}{t11}</Card>;
    $[24] = t11;
    $[25] = t3;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}
export { ServiceMarketplaceCard };